var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2236 2.41357C6.70363 2.41357 2.22363 6.89357 2.22363 12.4136C2.22363 17.9336 6.70363 22.4136 12.2236 22.4136C17.7436 22.4136 22.2236 17.9336 22.2236 12.4136C22.2236 6.89357 17.7436 2.41357 12.2236 2.41357ZM16.2236 13.4136H13.2236V16.4136C13.2236 16.9636 12.7736 17.4136 12.2236 17.4136C11.6736 17.4136 11.2236 16.9636 11.2236 16.4136V13.4136H8.22363C7.67363 13.4136 7.22363 12.9636 7.22363 12.4136C7.22363 11.8636 7.67363 11.4136 8.22363 11.4136H11.2236V8.41357C11.2236 7.86357 11.6736 7.41357 12.2236 7.41357C12.7736 7.41357 13.2236 7.86357 13.2236 8.41357V11.4136H16.2236C16.7736 11.4136 17.2236 11.8636 17.2236 12.4136C17.2236 12.9636 16.7736 13.4136 16.2236 13.4136Z",
    fill: "#001D4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a83184156f9a855b6cec7c8245343f6d.svg";
export { ForwardRef as ReactComponent };